import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Auth from './pages/Auth';
import Dashboard from './pages/Dashboard';
import Pricing from './pages/Pricing';
import PublicDomain from './pages/PublicDomain';
import { StoreProvider, useStore } from './context/Store';
import '@questlabs/react-sdk/dist/style.css';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useStore();
  if (loading) return <div>Loading...</div>;
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <StoreProvider>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Auth type="login" />} />
          <Route path="/signup" element={<Auth type="signup" />} />
          <Route path="/pricing" element={<Pricing />} />
          
          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />

          {/* Public Domain Landing Page Route */}
          <Route path="/d/:domainName" element={<PublicDomain />} />
        </Routes>
      </Router>
    </StoreProvider>
  );
}

export default App;